import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class ReviewService {


  constructor(private http: HttpClient) { }

  getAll(params?){
    return this.http.get('https://fsetan.ru/api/reviews/', {params});
  }
}
